import { CalendarRefreshIcon } from './CalendarRefreshIcon';

/**
 * author: Michael Irigoyen
 * id 4147C0BC-E3AE-4324-AA38-D2EC7A7AAD5E
 * name calendar-refresh
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-refresh.svg
 * tags
 * - Date / Time 
 */
export const CalendarRepeatIcon = CalendarRefreshIcon;
export default CalendarRepeatIcon